import { useApiMutation, refetch, onSuccess } from "../../utils/api";
import { Modal } from "react-bootstrap";
import { ModalBase } from "../../utils/modal_launcher";
import { SimpleForm } from "../../utils/simple_form";
import { toast } from "react-toastify";

const EditIdeaModal = ({ idea, close, groups }) => {
  const { post } = useApiMutation();

  const submit = (idea) => {
    post(`/api/user/update_idea/${idea.id}`, { idea }).then(
      onSuccess(() => {
        close();
        refetch("idea-board");
        toast.success("Idea updated");
      })
    );
  };

  const deleteIdea = () => {
    if (confirm("Delete this idea?")) {
      post(`/api/user/delete_idea/${idea.id}`).then(
        onSuccess(() => {
          toast.success("Idea deleted");
          close();
          refetch("idea-board");
        })
      );
    }
  };

  return (
    <ModalBase title="Edit Idea" close={close}>
      <Modal.Body>
        <SimpleForm
          fields={{
            idea_type: {
              label: "Category",
              type: "select_creatable",
              options: groups.map((group) => group.title),
              placeholder: "Select or type a category",
              required: true,
            },
            title: { required: true },
            cost: {},
            link: {},
            image: {},
          }}
          data={idea}
          onSubmit={submit}
          inlineActions={
            <button className="btn btn-text" type="button" onClick={deleteIdea}>
              <i className="bi bi-trash red" />
            </button>
          }
        />
      </Modal.Body>
    </ModalBase>
  );
};

export default EditIdeaModal;
